import { useTranslation } from 'src/utils/i18n'
import { localPhoneSendEmailandroid } from 'src/@api/android'

const NewProgress3 = ({ setPhoneType, setNowPage }) => {

  const { t } = useTranslation('commonAndroid')

  // 选择其他品牌手机时发送邮件
  const selectOtherPhone = async () => {
    try {
      //获取用户邮箱
      const email = JSON.parse(localStorage.getItem('userData'))?.data.email

      // 调用发邮件接口(code:0 成功)
      await localPhoneSendEmailandroid({ email })

      setNowPage(2)
      setPhoneType('other')
    } catch (e) {
      console.log('send Email RunTimeExection Error', e)
    }
  }

  return (
    <div className='mx-[22px] flex flex-col items-center'>
      <h2 className='text-[24px] text-center text-[#2B2D33] font-[600] leading-[32px] mb-[60px] lg:text-nowrap'>{t('Select the brand of monitored phone')}</h2>
      <button className='w-[213px] h-[76px] px-[16px] mb-4 text-[18px] text-[#222222] font-[400] leading-[24px]
        [border:1px_solid_#D3D6DE] rounded-[10px] break-all hover:[background:linear-gradient(to_bottom,#ECF3FE,#FDFEFF)] hover:border-[#0481FF] text-center' onClick={() => {
          setNowPage(2)
          setPhoneType('samsung')
        }}>{t('Samsung')}</button>
      <button className='w-[213px] h-[76px] px-[16px] mb-4 text-[18px] text-[#222222] font-[400] leading-[24px]
        [border:1px_solid_#D3D6DE] rounded-[10px] break-all hover:[background:linear-gradient(to_bottom,#ECF3FE,#FDFEFF)] hover:border-[#0481FF] text-center' onClick={() => {
          setNowPage(2)
          setPhoneType('xiaomi')
        }}>{t('Xiaomi')}</button>
      <button className='w-[213px] h-[76px] px-[16px] text-[18px] text-[#222222] font-[400] leading-[27px]
        [border:1px_solid_#D3D6DE] rounded-[10px] break-all hover:[background:linear-gradient(to_bottom,#ECF3FE,#FDFEFF)] hover:border-[#0481FF] text-center' onClick={() => {
          setNowPage(2)
          setPhoneType('other')
        }}>
        <span className='block'>{t('othersText1')}</span>
        <span>{t('othersText2')}</span>
      </button>
    </div>
  )
}

export default NewProgress3
